import { AutogenLayoutPurgeControl } from "./autogen/AutogenLayoutPurgeControl";

export class PurgeControl extends AutogenLayoutPurgeControl {

}
